// extracted by mini-css-extract-plugin
export default {"cancelProcessStepWarning":"cancelProcessStepWarning-lS7oq","text":"text-K2Tbv","instructionGroup":"instructionGroup-y5Tfq"};